import jmespath from "jmespath";

const getAllGeojsonFeatureProperties = (geojson) => {
	return jmespath.search(geojson.features, "[*].properties");
};

export { getAllGeojsonFeatureProperties };
